import styled from '@emotion/styled';
import AuraLogo from '@trinity/chat-components/static/images/aura-icon.svg?url';

export type ChatWithDigitalTwinsButtonProps = {
  className?: string;
  onClick: () => void;
};

/**
 * The gradient "Chat with Digital Twins" CTA shown above the segments table — navigates to the
 * HCPDigitalTwins gallery/chat screen. Takes a plain onClick (not a `to` route) since each app
 * resolves its own target path.
 */
export const ChatWithDigitalTwinsButton = ({ className, onClick }: ChatWithDigitalTwinsButtonProps) => (
  <Button type="button" className={className} onClick={onClick}>
    <img src={AuraLogo} alt="" aria-hidden="true" />
    Chat with Digital Twins
  </Button>
);

const Button = styled.button({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,
  height: 40,
  padding: '8px 16px',
  border: 'none',
  borderRadius: 5,
  boxSizing: 'border-box',
  cursor: 'pointer',
  fontSize: 16,
  fontWeight: 600,
  background: 'linear-gradient(90deg, rgb(73, 37, 255) 0%, rgb(92, 93, 167) 35%, rgb(39, 170, 225) 100%)',
  color: 'white',
  '& img': {
    width: 20,
    height: 20,
    flexShrink: 0,
  },
});
